@if (type === 'button') {
  <p-button
    [styleClass]="'controls__button button-secondary wishlist'"
    [pTooltip]="isInWishlist ? savedInWishListTooltip : saveToWishListTooltip"
    [disabled]="loading"
    [ngClass]="{ active: isInWishlist }"
    [loading]="loading"
    [tooltipOptions]="hintOptions"
    [label]="isInWishlist ? savedInWishListLabel : saveToWishListLabel"
    userCta
    (authorizedClick)="onToggleButton()"
    (mouseenter)="focus = true"
    (mouseleave)="focus = false"
  >
    <ng-template pTemplate="icon">
      <fa-icon [icon]="isInWishlist || focus ? bookMarkSolidIcon : bookmarkIcon" [size]="'lg'"></fa-icon>
    </ng-template>
  </p-button>
} @else {
  <p-button
    [pTooltip]="isInWishlist ? savedInWishListTooltip : saveToWishListTooltip"
    [tooltipOptions]="hintOptions"
    [disabled]="loading"
    [loading]="loading"
    styleClass="p-button-rounded"
    [ngClass]="{ active: isInWishlist }"
    userCta
    (authorizedClick)="onToggleButton()"
    (mouseenter)="focus = true"
    (mouseleave)="focus = false"
  >
    <ng-template pTemplate="icon">
      <fa-icon [icon]="bookmarkIcon" [size]="'lg'"></fa-icon>
    </ng-template>
  </p-button>
}
